export class UIState {
  /**
   * @type {string|null}
   */
  stickyBannerHeight;
}
